import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import {Pageable} from '../../../../../types/pagable.types';
import {
  RecordData,
  RecordTableColumnParams
} from '../../../../../types/records-table.types';
import {defaultPaginationData, repeatsTableColumnConfig} from '../../configs/repeats-table.config';
import {ResourceParams, resources} from "../../../../../models/resource/resources";
import {RecordsTableViewComponent} from "../../../../records-table-view/records-table-view.component";

@Component({
  selector: 'app-repeats-table',
  standalone: true,
  imports: [
    RecordsTableViewComponent
  ],
  templateUrl: './repeats-table.component.html',
  styleUrl: './repeats-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RepeatsTableComponent {
  resourceParamsKey = input<string>('');
  tableRecords = input<Array<RecordData>>([]);

  public columnsParams: Array<RecordTableColumnParams> = repeatsTableColumnConfig;
  public tableData = computed<Pageable<RecordData>>(() => {
    return {
      content: this.tableRecords(),
      ...defaultPaginationData
    }
  });

  public getResourceParams(key: string): ResourceParams {
    return key === 'record-lists-repeats' ?
      resources['record-lists-repeats'] :
      resources['record-calendars-repeats'];
  }
}
